export default __webpack_public_path__ + "static/media/i_bus-low_bl_tagless.f7219d3e.svg";